import React, { useState, useEffect, useRef } from 'react';
import StepLayout from '../components/StepLayout';
import SelectionCard from '../components/SelectionCard';
import { api } from '../api';

// iter-26: rebuild — orange selection pattern via shared SelectionCard.
// Auto-advance on click preserved from iter-24; manual Next stays as a
// keyboard fallback. Trustpilot mounts via StepLayout's global iter-24
// hook. Spec consistency note: same orange pattern is used on ID Type,
// Referral Source, and Final Details Gender.
const OPTIONS = [
  { value: 'GB', label: 'UK' },
  { value: 'US', label: 'United States' },
];

export default function Step04Country({ step, totalSteps, sessionId, sessionData, updateData, onNext }) {
  const [country, setCountry] = useState(sessionData.country || '');
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const advancedRef = useRef(false);

  const handleNext = async (countryOverride) => {
    const value = countryOverride || country;
    if (!value || advancedRef.current) return;
    advancedRef.current = true;
    setLoading(true);
    setSubmitError('');
    try {
      await api.updateLocation(sessionId, { country: value });
      updateData({ country: value });
      onNext();
    } catch (err) {
      advancedRef.current = false;
      setSubmitError(err.message || 'Failed to save country.');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!country || advancedRef.current) return;
    const t = setTimeout(() => {
      handleNext(country);
    }, 250);
    return () => clearTimeout(t);
  }, [country]);

  const canSubmit = !!country && !loading;

  return (
    <StepLayout title="Which country are you from? *">
      <div
        role="radiogroup"
        aria-label="Country"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 12,
          marginBottom: 32,
        }}
      >
        {OPTIONS.map((opt) => (
          <SelectionCard
            key={opt.value}
            id={`country-${opt.value}`}
            name="country"
            value={opt.value}
            label={opt.label}
            selected={country === opt.value}
            onSelect={setCountry}
            disabled={loading}
          />
        ))}
      </div>

      {submitError && (
        <p style={{ color: 'var(--danger)', fontSize: 12, marginTop: -16, marginBottom: 16 }}>
          {submitError}
        </p>
      )}

      <div className="cta-row">
        <button
          type="button"
          onClick={() => handleNext()}
          disabled={!canSubmit}
          aria-disabled={!canSubmit}
          className="cta-row__btn primary-cta"
        >
          {loading ? 'Saving...' : 'Next'}
        </button>
      </div>
    </StepLayout>
  );
}
